import { useEffect } from "react";

import { Box } from "@chakra-ui/react";

import { sanitizeHref } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

const NavLinks = () => {
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const { headerLinks } = useAppSelector((state) => state.navigationLinks);
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const textColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarTextColor;

  useEffect(() => {
    // @ts-ignore
    if (typeof MetisMenu === "function") {
      // @ts-ignore
      // eslint-disable-next-line no-undef
      const dropdownMenu = new MetisMenu("#js-nav-links").on(
        "shown.metisMenu",
        function (event) {
          window.addEventListener("mousedown", function dropdown(e) {
            if (!event.target.contains(e.target)) {
              dropdownMenu.hide(event.detail.shownElement);

              window.removeEventListener("mousedown", dropdown);
            }
          });
        }
      );
    }
  }, []);

  const dropdownNode = (item, index) => {
    if (item.children.length) {
      return (
        <li key={index} className="nav-links__list__list-item">
          <a
            href={sanitizeHref(item.linkableUrl)}
            aria-expanded="false"
            className="nav-links__list__list-item__link"
          >
            <span>{item.title}</span>
          </a>
          <Box
            as="ul"
            className="nav-links__list__list-item__child"
            color={textColor}
            backgroundColor={backgroundColor}
          >
            {item.children.map((child, childIndex) => {
              return dropdownNode(child, childIndex);
            })}
          </Box>
        </li>
      );
    }
    return (
      <li key={index} className="nav-links__list__list-item">
        <a
          href={sanitizeHref(item.linkableUrl)}
          className="metismenu nav-links__list__list-item__link"
        >
          <span>{item.title}</span>
        </a>
      </li>
    );
  };

  headerLinks.map((l) => !l.children && (l.children = []));

  const links = headerLinks.filter((l) => l.parentId === null);

  return (
    <div className="nav-links">
      <ul className="metismenu nav-links__list" id="js-nav-links">
        {links.map((item, index) => {
          return dropdownNode(item, index);
        })}
      </ul>
    </div>
  );
};

export default NavLinks;
